var rich_content_viewer_default = {
  "fontElementMap": "VOKQJ",
  "wrapper": "OWzcq",
  "pluginContainerMobile": "Ps4z4",
  "viewer": "-n--z",
  "android": "Oz8-p",
  "rootedTraversedContent": "am0K-",
  "atomic": "w7lnG",
  "toolbar": "zOLnG",
  "block": "-cUpr"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
